<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="job"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <job-search
        v-model="item.job"
        :form-state="formState"
        name="job"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.job"
        @update-job="updateJob"
        :create="create"
        :address="item.job__site_address"
        :suburb="item.job__suburb"
        :job_number="item.job"
        :isMaterialAndSupply="true"
      ></job-search>
      <br />
      <o-widget-wrapper
        :schema="schema"
        name="job__pour_date"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-date-time
          readonly
          v-model="item.job__pour_date"
          name="job__pour_date"
          v-bind="schema.fields.job__pour_date"
          :form-state="formState"
          :validators="$v.item"
          :server-errors="_se"
          hide-time
        ></o-date-time>
      </o-widget-wrapper>
      <o-widget-wrapper
        :schema="schema"
        name="job_no"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-text-field
          readonly
          :value="display_job_no"
          :form-state="formState"
          name="job_no"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.job_no"
        ></o-text-field>
      </o-widget-wrapper>
      <o-widget-wrapper
        :schema="schema"
        name="job__site_address"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-text-field
          readonly
          v-model="item.job__site_address"
          :form-state="formState"
          name="job__site_address"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.job__site_address"
        ></o-text-field>
      </o-widget-wrapper>
      <o-widget-wrapper
        :schema="schema"
        name="job_suburb"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-text-field
          readonly
          v-model="item.job__suburb"
          :form-state="formState"
          name="job_suburb"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.job_suburb"
        ></o-text-field>
      </o-widget-wrapper>
      <o-widget-wrapper
        :schema="schema"
        name="job_supervisor"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-text-field
          readonly
          v-model="item.job__supervisor"
          :form-state="formState"
          name="job_supervisor"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.job_supervisor"
        ></o-text-field>
      </o-widget-wrapper>
      <o-widget-wrapper
        :schema="schema"
        name="job_customer"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-text-field
          readonly
          :value="display_customer_name"
          :form-state="formState"
          name="job_customer"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.job_customer"
        ></o-text-field>
      </o-widget-wrapper>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="supplier"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.supplier"
        :items="optionSupplierItems"
        text-field="display_name"
        value-field="id"
        sort-field="display_name"
        :form-state="formState"
        :loading="optionSupplierWorking"
        name="supplier"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.supplier"
        allow-add
        store-name="Supplier"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <supplier-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></supplier-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.type"
        :items="optionCodeTaskTypeItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeTaskTypeWorking"
        name="type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.type"
        allow-add
        store-name="CodeTaskType"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-task-type-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></code-task-type-form>
        </template>
      </o-select>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="no_allowed"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.no_allowed"
        :form-state="formState"
        name="no_allowed"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.no_allowed"
      ></o-checkbox>
    </o-widget-wrapper>
    <!-- <o-widget-wrapper
      :schema="schema"
      name="allowed"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        v-model="item.allowed"
        :form-state="formState"
        name="allowed"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.allowed"
        @input="getAllowed"
        default-class="w-50"
      ></o-money-field>
    </o-widget-wrapper> -->
    <o-widget-wrapper
      :schema="schema"
      name="allowed"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        :readonly="item.no_allowed"
        v-model="item.allowed"
        :form-state="formState"
        name="allowed"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.allowed"
      ></o-money-field>
      <!-- prepend="$"
        default-class="w-50"
        col-size="6" -->
      <!-- <o-text-field
        :readonly="item.no_allowed"
        v-model="item.allowed"
        :form-state="formState"
        name="allowed"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.allowed"
      ></o-text-field> -->
    </o-widget-wrapper>

    <!-- <o-widget-wrapper
      :schema="schema"
      name="amount_ordered"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        v-model="item.amount_ordered"
        :form-state="formState"
        name="amount_ordered"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.amount_ordered"
        @input="getAmountOrdered"
        default-class="w-50"
      ></o-money-field>
    </o-widget-wrapper> -->
    <o-widget-wrapper
      :schema="schema"
      name="amount_ordered"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        :readonly="item.no_allowed"
        v-model="item.amount_ordered"
        :form-state="formState"
        name="amount_ordered"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.amount_ordered"
      ></o-money-field>
      <!-- prepend="$"
        default-class="w-50"
        col-size="6" -->
      <!-- <o-text-field
        v-model="item.amount_ordered"
        :form-state="formState"
        name="amount_ordered"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.amount_ordered"
      ></o-text-field> -->
    </o-widget-wrapper>
    <!-- <o-widget-wrapper
      :schema="schema"
      name="amount_used"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        v-model="item.amount_used"
        :form-state="formState"
        name="amount_used"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.amount_used"
        @input="getAmountUsed"
        default-class="w-50"
      ></o-money-field>
    </o-widget-wrapper> -->
    <o-widget-wrapper
      :schema="schema"
      name="amount_used"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        v-model="item.amount_used"
        :form-state="formState"
        name="amount_used"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.amount_used"
      ></o-money-field>
      <!-- prepend="$"
        default-class="w-50"
        col-size="6" -->
      <!-- <o-text-field
        v-model="item.amount_used"
        :form-state="formState"
        name="amount_used"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.amount_used"
      ></o-text-field> -->
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="discrepency"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        default-class="w-100"
        :changeColor="item.discrepency > 0 ? 'border-red' : 'border-green'"
        col-size="12"
        v-model="calculate"
        :form-state="formState"
        name="discrepency"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.discrepency"
        readonly
      ></o-money-field>
      <!-- prepend="$" -->
      <!-- <o-text-field
        readonly
        v-model="item.discrepency"
        :form-state="formState"
        name="discrepency"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.discrepency"
      ></o-text-field> -->
    </o-widget-wrapper>

    <!-- create extra button here -->
    <b-container
      v-if="(showNewExtra && !item.extra) || (showNewExtra && item.extra)"
      fluid="xs"
    >
      <b-row>
        <b-col v-if="showNewExtra && !item.extra" class="text-right pr-0"
          >Create New Extra</b-col
        >
        <b-col v-if="showNewExtra && item.extra" class="text-right pr-0"
          >Update Extra</b-col
        >
        <b-col cols="10">
          <b-button
            :disabled="showLoadingCreateExtra"
            class="mr-2"
            v-if="showNewExtra && !item.extra"
            @click="createNewExtra()"
            variant="success"
          >
            <b-spinner
              v-if="showLoadingCreateExtra"
              small
              label="Spinning"
            ></b-spinner>
            Create Extra
          </b-button>
          <b-button
            @click="gotoEditExtra()"
            class="mr-2"
            v-if="showNewExtra && item.extra"
            variant="primary"
          >
            Open Extra
          </b-button>
        </b-col>
      </b-row>
      <br />
    </b-container>
    <!-- <b-container v-if="newExtra.code || item.extra__code" fluid="xs">
      <b-row>
        <b-col class="text-right pr-0">Extra:</b-col>
        <b-col cols="10">
         <b-col class="text-left ">{{this.newExtra.code || this.item.extra__code}}</b-col>
        </b-col>
      </b-row>
      <br />
    </b-container> -->
    <!-- {{newExtra}}
    <br>
    {{item}} -->
    <o-widget-wrapper
      v-if="item.extra"
      :schema="schema"
      name="extra_raised_by"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        readonly
        :value="newExtra.entered_by__username || item.extra_raised_by"
        :form-state="formState"
        name="extra_raised_by"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.extra_raised_by"
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      v-if="item.extra"
      :schema="schema"
      name="extra_code"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        readonly
        :value="newExtra.code || item.extra__code"
        :form-state="formState"
        name="extra_code"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.extra_code"
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      v-if="item.extra"
      :schema="schema"
      name="date_extra_created"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        readonly
        :value="newExtra.created_date || item.date_extra_created"
        name="date_extra_created"
        v-bind="schema.fields.date_extra_created"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="item.extra"
      :schema="schema"
      name="date_po_received"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <template
        v-for="(date, index) in newExtra.purchase_orders ||
        item.extra_details.purchase_orders"
      >
        <o-date-time
          :key="index"
          readonly
          :value="date.date_po_supplied ? date.date_po_supplied : '-'"
          name="date_po_received"
          v-bind="schema.fields.date_po_received"
          :form-state="formState"
          :validators="$v.item"
          :server-errors="_se"
          hide-time
        ></o-date-time>
      </template>
    </o-widget-wrapper>
    <!-- <o-widget-wrapper
      v-if="item.extra"
      :schema="schema"
      name="date_po_received"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        readonly
        :value="newExtra.date_po_requested || item.date_po_received"
        name="date_po_received"
        v-bind="schema.fields.date_po_received"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper> -->

    <o-widget-wrapper
      v-if="item.extra"
      :schema="schema"
      name="date_po_invoiced"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <template
        v-for="(date, index) in newExtra.purchase_orders ||
        item.extra_details.purchase_orders"
      >
        <o-date-time
          :key="index"
          readonly
          :value="date.date_invoiced ? date.date_invoiced : '-'"
          name="date_po_invoiced"
          v-bind="schema.fields.date_po_invoiced"
          :form-state="formState"
          :validators="$v.item"
          :server-errors="_se"
          hide-time
        ></o-date-time>
      </template>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="notes"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-notes-table
        :form-state="formState"
        :label="schema.fields.notes.label"
        :level="level + 1"
        :server-errors="_se.notes"
        :users="optionUserItemsById"
        :users-working="optionUserWorking"
        :validator="$v.item.notes"
        model-name="Note"
        v-model="item.notes"
        when-field="when"
        who-field="who"
      >
      </o-notes-table>
      <!-- UNCOMMENT TO USE Cards
<note-form-cards v-model="item.repair_notes"
    :validators="$v.item.repair_notes"
    :form-state="formState"
    :label="schema.fields.repair_notes.label"
    :level="level+1"
    :server-errors="_se.repair_notes">
</note-form-cards>
--> </o-widget-wrapper
    ><br />
    <!-- <b-container fluid="xs">
        <b-row>
          <b-col class="text-right pr-0">Date Invoiced</b-col>
          <b-col cols="10">
            <ul v-for="(date, index) in item.date_po_invoiced" :key="index">
              <li>
                {{
                  date.date_invoiced ? date.date_invoiced : "No Date Invoiced"
                }}
              </li>
            </ul>
            <template v-if="item.date_po_invoiced.length <= 0"
              >No Date Invoiced</template
            >
          </b-col>
        </b-row>
      </b-container> -->

    <!-- {{ this.item.extra }}

    {{ this.newExtra }} -->

    <!-- <o-widget-wrapper
      :schema="schema"
      name="extra"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.extra"
        :items="optionServiceExtraItems"
        text-field="code"
        value-field="id"
        sort-field="code"
        :form-state="formState"
        :loading="optionServiceExtraWorking"
        name="extra"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.extra"
        store-name="ServiceExtra"
      >
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="item.discrepency > 0"
      :schema="schema"
      name="extra_order_requested_by"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        readonly
        v-model="item.extra_order_requested_by"
        :form-state="formState"
        name="extra_order_requested_by"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.extra_order_requested_by"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="item.discrepency > 0"
      :schema="schema"
      name="date_extra_created"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        readonly
        v-model="item.date_extra_created"
        name="date_extra_created"
        v-bind="schema.fields.date_extra_created"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>
    <o-widget-wrapper
      v-if="item.discrepency > 0"
      :schema="schema"
      name="extra_code"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        readonly
        v-model="item.extra_code"
        :form-state="formState"
        name="extra_code"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.extra_code"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="item.discrepency > 0"
      :schema="schema"
      name="date_po_received"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        readonly
        v-model="item.date_po_received"
        name="date_po_received"
        v-bind="schema.fields.date_po_received"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="item.discrepency > 0 && item.date_po_invoiced.length > 0"
      :schema="schema"
      name="date_po_invoiced"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <b-container fluid="xs">
        <b-row>
          <b-col class="text-right pr-0">Date Invoiced</b-col>
          <b-col cols="10">
            <ul v-for="(date, index) in item.date_po_invoiced" :key="index">
              <li>
                {{
                  date.date_invoiced ? date.date_invoiced : "No Date Invoiced"
                }}
              </li>
            </ul>
            <template v-if="item.date_po_invoiced.length <= 0"
              >No Date Invoiced</template
            >
          </b-col>
        </b-row>
      </b-container> -->

    <!-- <template v-for="(date, index) in item.date_po_invoiced">
        <o-date-time
          :key="index"
          readonly
          v-model="date.date_invoiced"
          name="date_po_invoiced"
          v-bind="schema.fields.date_po_invoiced"
          :form-state="formState"
          :validators="$v.item"
          :server-errors="_se"
          hide-time
        ></o-date-time>
      </template> -->
    <!-- </o-widget-wrapper> -->
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { HasGroupMixin } from "../../../vue-ocom/auth/mixin/AuthFormMixins.js";
import { default as SupplierTypeMixin } from "../../job/mixins/supplier_type_mixin";

import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import ONumberField from "../../../vue-ocom/components/forms/fields/ONumberField";

import OMoneyField from "../../components/money_field/OMoneyField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import ONotesTable from "../../../vue-ocom/components/table/common/ONotesTable";

import { default as JobForm } from "../../job/components/ItemForm";
import { default as JobSearch } from "../../components/job_search/JobSearch";
import { default as SupplierForm } from "../../supplier/components/ItemForm";
import { default as CodeTaskTypeForm } from "../../code_task_type/components/ItemForm";
import { default as ServiceExtraForm } from "../../service_extra/components/ItemForm";
import moment from "moment";
import { mapActions, mapMutations } from "vuex";
import { EXTRA_TYPE_EXTRA } from "../../../lib/common";
import _ from "lodash";

export default {
  mixins: [
    HasGroupMixin("Administrator"),
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("MaterialsAndSupply"),
    CreateCodeTableFetchMixin([
      "Job",
      "Supplier",
      "CodeTaskType",
      "Employee",
      "User",
      "CodeSupplierType",
      // "ServiceExtra",
    ]),
    SupplierTypeMixin,
  ],
  components: {
    ONotesTable,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,
    JobSearch,
    OMoneyField,

    OCheckbox,
    OSelect,
    OTextField,
    ONumberField,

    JobForm,
    SupplierForm,
    CodeTaskTypeForm,
    ServiceExtraForm,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
    create: { type: Boolean, default: false },
    saveFirst: { type: Function, default: null },
  },
  data: () => ({
    newExtra: {},
    showLoadingCreateExtra: false,
    data: {
      job_type_description: "",
      allocated_to: null,
      approve_subcontractor_by: null,
      cancelled_by: null,
      po_no_supplied_by: null,
      raised_by: null,
      repair_notes: [],
      sub_contractor: null,
      supervisor_name: null,
      supervisor: null,
      used_materials: [],
      entered_by: null,
      extra_type: EXTRA_TYPE_EXTRA,
      date_raised_quoted: new Date().toISOString().split("T")[0],
      job: null,
      site_address: null,
      suburb: null,
      customer: null,
      builder: null,
      description: "",
      purchase_orders: [
        {
          created_date: null,
          modified_date: null,
          po_number: "",
          date_po_supplied: null,
          invoice_number: "",
          date_invoiced: null,
          invoiced_by: null,
          invoiced_by__username: null,
        },
      ],
      _new: true,
    },
    showNewExtra: false,
    discrepency: 0,
    have_discrepency: true,
    schemaModel: cleanUpModel(schema.MaterialsAndSupply, {}),
  }),
  methods: {
    ...mapMutations(["showMessage"]),
    ...mapActions("ServiceExtraModule", ["saveItem"]),
    OnBeforeGetEmployeeCodeList(list_options) {
      list_options.query = {
        and: [
          ["item_type", "eq", 1],
          ["entity", "eq", 1],
        ],
      };
    },
    gotoEditExtra() {
      if (this.newExtra.id || this.item.extra) {
        this.formState.dirty = false;
      }
      this.$router.push({
        name: "service_extra.edit",
        params: { id: this.newExtra.id || this.item.extra },
      });
      this.showNewExtra = !this.showNewExtra;
    },
    async createNewExtra() {
      var idCheck = _.find(this.optionEmployeeItems, {
        id: this.currentUser.id,
      });
      if (!idCheck) {
        this.showMessage({
          message: "You are not in the list of Employees who can Raise Extras",
          type: "danger",
          show: true,
        });
        return true;
      }
      if (!this.item.job) {
        this.showMessage({
          message: "Dont forget to add job first",
          type: "danger",
          show: true,
        });
        return true;
      }
      this.showLoadingCreateExtra = true;
      // this.data.raised_by = this.item.job_raised_by;
      this.data.raised_by = this.currentUser.id;
      await this.saveFirst((item) => {
        console.log("createNewExtra", item);
        this.item = item;
        var newExtraData = {
          ...this.data,
          description:
            `Extra ${this.data.job_type_description} Concrete required ` +
            this.item.amount_used +
            " of " +
            this.item.allowed,
          site_address: this.item.job__site_address,
          suburb: this.item.job__suburb,
          completed_date: null,
          cancelled_date: null,
          builder: this.item.job_details.customer,
          amount: this.item.discrepency,
          supervisor_name: this.item.job__supervisor,
          category_of_works: [],
        };

        // data
        this.saveItem(newExtraData)
          .then(async (res) => {
            this.item.extra = res.id;
            this.newExtra = res;
            await this.$emit("save");
            this.showNewExtra = true;
            this.showLoadingCreateExtra = false;
          })
          .catch((error) => {
            this.showLoadingCreateExtra = false;
            this.showMessage({
              message: "Something went wrong",
              type: "danger",
              show: true,
            });
            console.log(error);
          });
      });
    },
    updateJob(e) {
      this.item.job = e.id;
      this.item.job__site_address = e.site_address;
      this.item.job__supervisor = e.supervisor__name;
      this.item.job__suburb = e.suburb;
      this.item.job_customer = e.customer__name;
      this.item.job_raised_by = e.raised_by;
      this.item.job__pour_date = e.pour_date;
      this.item.job_no = e.id;
      this.data.job = e.id;
      this.data.suburb = e.suburb;
      this.data.site_address = e.site_address;
      this.data.supervisor_name = e.supervisor__name;

      this.data.builder = e.customer;
      this.data.customer = e.customer__name;
      this.data.entered_by = this.currentUser.id;
      this.data.job_type_description = e.job_type__description;

      console.log("updateJob", e);
      // console.log("updateJob", this.data);
    },
    // changeNoAllowed() {
    //   if (this.item.no_allowed) {
    //     // this.item.allowed = 0;
    //   }
    // },
    // calculateDiscrepancy() {
    //   let allowed = this.item.allowed ? this.item.allowed : 0;
    //   let amount_used = this.item.amount_used ? this.item.amount_used : 0;
    //   this.discrepency = allowed - amount_used;
    //   this.item.discrepency = this.discrepency ? this.discrepency : 0;

    //   if (this.discrepency > 0) {
    //     this.have_discrepency = true;
    //   } else {
    //     this.have_discrepency = false;
    //   }
    // },
  },
  computed: {
    checkCurrentUser() {
      this.data.entered_by = this.currentUser.id;
      return this.currentUser;
    },
    calculate() {
      // var discrepency = (this.item.discrepency =
      //   +this.item.amount_used - +this.item.allowed);
      // discrepency <= 0 ? (this.item.discrepency = 0) : null;
      var cal = +this.item.amount_used - +this.item.allowed;
      cal <= 0 ? (cal = 0) : cal;
      return (this.item.discrepency = cal.toFixed(2));
    },
    getItem() {
      return this.item.job;
    },
    getExtra() {
      return this.item.extra_details;
    },
    checkAllowedValue() {
      return this.item.allowed;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },

    display_job_no() {
      return this.item.job_no ? this.item.job_no : this.item.job;
    },
    display_supervisor() {
      return this.item.job_supervisor
        ? this.item.job_supervisor
        : this.item.job__supervisor;
    },
    display_customer_name() {
      return this.item.job_customer
        ? this.item.job_customer
        : this.item.job__customer__name;
    },
  },
  watch: {
    calculate() {
      if (Number(this.item.discrepency) > 0) {
        this.showNewExtra = true;
      } else {
        this.showNewExtra = false;
      }
    },
    getItem() {
      // isNaN(this.item.discrepency)
      //   ? (this.item.discrepency = 0)
      //   : this.item.discrepency;
      this.item.job__site_address = this.item.job__site_address;
      if (this.item.extra_details) {
        this.item.job_supervisor = this.item.extra_details.supervisor_name;
        this.item.job_suburb = this.item.extra_details.suburb;
        this.item.job_raised_by = this.item.extra_details.raised_by;
      }

      this.item.job_customer = this.item.job_details.customer__name;
      this.item.job_no = this.item.job;
      this.data.job = this.item.job;
      this.data.suburb = this.item.job_suburb;
      this.data.site_address = this.item.job__site_address;
      this.data.builder = this.item.job_details.customer;
      this.data.customer = this.item.job_details.customer__name;
      this.data.entered_by = this.currentUser.id;
    },
    getExtra() {
      // console.log('getExtra', this.item.extra_details)
      this.newExtra = this.item.extra_details;
    },
    // getExtra() {
    //   const extra = this.optionServiceExtraItems.filter(
    //     (extraaa) => extraaa.id === this.getExtra
    //   );
    //   // console.log("extra", extra);
    //   if (extra.length > 0) {
    //     this.item.extra_order_requested_by = extra[0].raised_by__name;
    //     this.item.date_extra_created = extra[0].created_date;
    //     this.item.extra_code = extra[0].code;
    //     this.item.date_po_received = extra[0].date_po_requested;
    //     this.item.date_po_invoiced = extra[0].purchase_orders;
    //   }
    // },
  },
  created() {
    if (!this.item.allowed) {
      this.item.allowed = 0;
    }

    if (!this.item.amount_used) {
      this.item.amount_used = 0;
    }
    if (!this.item.amount_ordered) {
      this.item.amount_ordered = 0;
    }
    this.item.allowed = this.item.allowed.toFixed(2);
    this.item.amount_used = this.item.amount_used.toFixed(2);
    this.item.amount_ordered = this.item.amount_ordered.toFixed(2);
  },
  mounted() {},
  updated() {
    // if (!this.item.allowed) {
    // this.item.allowed = this.item.allowed.toFixed(2);
    // this.item.amount_used = this.item.amount_used.toFixed(2);
    // this.item.amount_ordered =this.item.amount_ordered.toFixed(2);
    // }
    // if (!this.item.amount_used) {
    // }
  },
};
</script>
